import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Country} from '../../../../models/country';
import {Platform} from '../../../../models/platform';
import {TranslateService} from '@ngx-translate/core';
import {ActivitySearchCriteria, GroupSearch} from '../../../../models/group-search';
import {CommonConstant, InfluencerSortByEnum} from '../../../app.constants';
import {ActivityFiltersComponent} from './activity-filters/activity-filters.component';
import { TargetType, EventTrackerService, UserActionType, Page, ActionSource, ActivePages } from '../../../services/event-tracker/event-tracker.service';
import { InfluencerGroup } from '../../../../models/influencer-group';
import { AudienceFilterComponent } from '../../discover/discover-search/audience-filter/audience-filter.component';
import { DiscoverAudienceFilter } from '../../../../models/discover';
import { InfluencerSearch } from '../../../../models/influencer-search';
import { Influencer } from '../../../../models/influencer';

@Component({
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit, AfterViewInit {
  @Input()
  public countryList: Country[];
  @Input()
  public platFormList: Platform[];
  @Input()
  public influencerGroupId: number;
  @Input()
  public influencerGroup: InfluencerGroup;
  @Input()
  public campaignData: any;
  @Output()
  public checkEvent = new EventEmitter<any>();
  @Output()
  public searchEvent = new EventEmitter<any>();
  @ViewChild('activityFilter')
  activityFilter: ActivityFiltersComponent;
  @ViewChild('audienceFilter')
  audienceFilter: AudienceFilterComponent;
  @Input()
  public groupSearch: GroupSearch = new GroupSearch();
  @Input()
  public showSearchBar: boolean;
  @Input()
  public isCampaignInfluencer = false;
  @Input()
  public influencerSearch: InfluencerSearch = new InfluencerSearch();
  @Input()
  isActiveDiscoverFollower: boolean;

  public checkAll: boolean;
  public numberOfNew = {numberOfNew: 3};
  public showActivityFilter: boolean;
  public genderList: any[];
  public hasFilterActivity = false;
  public showAudienceFilter: boolean;

  constructor(private translate: TranslateService,
              private eventTracker: EventTrackerService) {}

  ngOnInit() {
    this.genderList = CommonConstant.GENDERS;
  }

  ngAfterViewInit() {
    if (this.showSearchBar) {
      this.updateActivityFilter();
    }
  }

  onCheckSelectAll(event) {
    this.checkEvent.emit(this.checkAll);
  }

  showHideSearchbar($event) {
    this.showSearchBar = !this.showSearchBar;
  }

  searchInfluencers(item?, targetName?) {
    Object.keys(this.groupSearch).forEach(key => {
      if (this.groupSearch[key] === null) {
        this.groupSearch[key] = undefined;
      }
    });
    this.searchEvent.emit(this.groupSearch);
    if (item && targetName) {
      this.trackFilterEvent(item, targetName);
    }
  }

  private trackFilterEvent(item, targetName) {
    const target = {
      type: TargetType.FILTER,
      name: targetName,
      id: targetName,
      filterName: item.name,
      filterId: item.id
    };
    // track event to Segment
    if (this.isCampaignInfluencer) {
      this.trackEventOnCampaign(this.campaignData, target);
    } else {
      this.trackEventOnGroup(this.influencerGroup, target);
    }
  }

  private trackEventOnGroup(influencerGroup, target) {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP,
      target,
      {
        action: UserActionType.TOGGLE,
        source: ActionSource.PAGE,
      }, undefined, {
        type: ActivePages.GROUP_DETAILS,
        id: influencerGroup.influencer_group_id,
        name: influencerGroup.influencer_group_name
      });
  }

  private trackEventOnCampaign(campaign, target) {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN_DETAILS,
      target,
      {
        action: UserActionType.TOGGLE,
        source: ActionSource.PAGE,
      }, undefined, {
        type: ActivePages.CAMPAIGN_DETAILS,
        id: campaign.id,
        name: campaign.name
      });
  }

  clearFilter() {
    this.groupSearch.selectedCountry = undefined;
    this.groupSearch.selectedPlatform = undefined;
    this.groupSearch.selectedGender = undefined;
    if (this.activityFilter) {
      this.activityFilter.resetActivityFilters();
    }
    if (this.audienceFilter) {
      this.audienceFilter.resetAudienceFilters();
    }
  }

  searchInfluencerByActivity(criteria: ActivitySearchCriteria) {
    // update reach search criteria
    if (criteria.selectedReach) {
      this.hasFilterActivity = true;
      this.groupSearch.reachFrom =  criteria.selectedReach.from;
      this.groupSearch.reachTo = criteria.selectedReach.to < CommonConstant.MAX_REACH_FOLLOWER ? criteria.selectedReach.to : undefined;
    }

    // update engagement search criteria
    if (criteria.selectedEngagement) {
      this.hasFilterActivity = true;
      this.groupSearch.engagementFrom =  criteria.selectedEngagement.from;
      this.groupSearch.engagementTo =  criteria.selectedEngagement.to < CommonConstant.MAX_REACH_ENGAGEMENT ? criteria.selectedEngagement.to : undefined;
    }

    // update impact search criteria
    if (criteria.selectedImpact) {
      this.hasFilterActivity = true;
      this.groupSearch.impactFrom =  criteria.selectedImpact.from;
      this.groupSearch.impactTo =  criteria.selectedImpact.to;
    }

    // update follower search criteria
    if (criteria.selectedFollower) {
      this.hasFilterActivity = true;
      this.groupSearch.followerFrom =  criteria.selectedFollower.from;
      this.groupSearch.followerTo =  criteria.selectedFollower.to;
    }

    const item = {
      id: criteria,
      name: criteria
    };
    this.searchInfluencers(item, 'Activity');
    this.showActivityFilter = false;
  }

  resetActivityFilters() {
    // reset reach condition
    this.groupSearch.reachFrom = undefined;
    this.groupSearch.reachTo = undefined;

    // reset engagement condition
    this.groupSearch.engagementFrom = undefined;
    this.groupSearch.engagementTo = undefined;

    // reset impact condition
    this.groupSearch.impactFrom = undefined;
    this.groupSearch.impactTo = undefined;

    // reset follower condition
    this.groupSearch.followerFrom = undefined;
    this.groupSearch.followerTo = undefined;

    // reset filter box
    this.hasFilterActivity = false;
    // search again
    this.searchInfluencers();
  }

  private updateActivityFilter() {
    if (this.groupSearch.reachFrom || this.groupSearch.reachTo || this.groupSearch.engagementFrom
      || this.groupSearch.engagementTo || this.groupSearch.impactFrom || this.groupSearch.impactTo) {
      this.hasFilterActivity = true;
      this.activityFilter.updateActivityUI(this.groupSearch.reachFrom, this.groupSearch.reachTo, this.groupSearch.engagementFrom,
        this.groupSearch.engagementTo, this.groupSearch.impactFrom, this.groupSearch.impactTo);
    }
  }

  onHideActivityFilters(e) {
    this.showActivityFilter = false;
  }

  onClickActivityFilters(e) {
    e.stopPropagation();
    if (this.showActivityFilter) {
      this.showActivityFilter = false;
    } else {
      this.showActivityFilter = true;
    }
  }

  orderInfluencerList(order) {
    let isAscendingOrder = 1;
    if (order === InfluencerSortByEnum.REACH || order === InfluencerSortByEnum.ENGAGEMENT || order === InfluencerSortByEnum.IMPACT || order === InfluencerSortByEnum.STATUS) {
      isAscendingOrder = 0;
    }
    if (this.hasOrderBy(order)) {
      this.groupSearch.orderBy = undefined;
      this.groupSearch.isAscendingOrder = isAscendingOrder;
    } else {
      this.groupSearch.orderBy = order;
      this.groupSearch.isAscendingOrder = isAscendingOrder;
      // track event to Segment
      this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
        type: TargetType.SORT,
        id: order,
        name: order
      },
      {
        action: UserActionType.TOGGLE,
        source: ActionSource.PAGE,
      }, undefined, {
        type: !this.isCampaignInfluencer ? ActivePages.GROUP_DETAILS : ActivePages.CAMPAIGN_DETAILS,
        id: !this.isCampaignInfluencer ? this.influencerGroup.influencer_group_id : order,
        name: !this.isCampaignInfluencer ? this.influencerGroup.influencer_group_name : order
      });
    }
    this.searchInfluencers();
  }

  hasOrderBy(orderField) {
    if (!this.groupSearch.orderBy && !this.influencerSearch.orderBy) {
      return false;
    }
    return (this.groupSearch.orderBy === orderField || this.influencerSearch.orderBy === orderField.toLowerCase());
  }
}



// WEBPACK FOOTER //
// ./src/app/main/group-details/search-bar/search-bar.component.ts